module.exports = __webpack_public_path__ + "14b972b8f220630179190564500088d6.svg";